import { useState, useEffect, useCallback } from 'react';

const TOKEN = 'asdknjasdfoihasldf89wr78y9r3w8e9234';
const FLAG_KEY = 'hazard_display';
const API_BASE = 'https://api.monitgps.pl/sse';

export const useAlertFlag = () => {
    const [isActive, setIsActive] = useState(false);
    const [updatedAt, setUpdatedAt] = useState(null);
    const [updatedBy, setUpdatedBy] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchFlag = useCallback(async () => {
        try {
            setLoading(true);
            const res = await fetch(`${API_BASE}/flag_get.php?token=${TOKEN}&flag=${FLAG_KEY}`);
            if (res.ok) {
                const data = await res.json();
                if (data.ok) {
                    setIsActive(!!data.is_active);
                    setUpdatedAt(data.updated_at);
                    setUpdatedBy(data.updated_by);
                }
            }
        } catch (err) {
            console.error('[useAlertFlag] Error fetching flag:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    const updateFlag = async (newValue) => {
        try {
            setLoading(true);
            const res = await fetch(`${API_BASE}/flag_update.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: TOKEN,
                    flag_key: FLAG_KEY,
                    is_active: newValue
                }),
            });
            if (res.ok) {
                const data = await res.json();
                if (data.ok) {
                    setIsActive(!!data.is_active);
                    setUpdatedAt(data.updated_at);
                    setUpdatedBy(data.updated_by);
                }
            }
        } catch (err) {
            console.error('[useAlertFlag] Error updating flag:', err);
        } finally {
            setLoading(false);
        }
    };

    const toggle = () => updateFlag(!isActive);
    const setActive = (bool) => updateFlag(bool);

    useEffect(() => {
        fetchFlag();
    }, [fetchFlag]);

    return { isActive, updatedAt, updatedBy, loading, toggle, setActive };
};
